import { Colors, Services, isEmpty } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import fileSticker from '@/components/file/sticker'
import info from '@/components/info'

function renderTTSSelect(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.tts,
        label: this.getTranslate('sendingsCreate.voice.voice'),
        items: this.ttsTypes,
        dense: true,
        details: false,
        disabled: this.loading
      },
      on: {
        input: event => {
          this.proxy.tts = event
        }
      }
    }
  )
}

function renderGenerateButton(h) {
  return h(
    button,
    {
      props: {
        label: this.buttonLabel,
        color: Colors.secondary,
        mode: buttonModes.outline,
        fullWidth: true,
        loading: this.loading,
        disabled: this.generateDisabled
      },
      on: {
        click: this.generateHandler
      }
    }
  )
}
function renderFirstRow(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__form-tts-row`
    },
    [
      renderTTSSelect.call(this, h),
      renderGenerateButton.call(this, h)
    ]
  )
}

function renderFilePlayer(h) {
  if (this.ttsFile) {
    return h(
      fileSticker,
      {
        props: {
          value: this.ttsFile
        },
        on: {
          remove: this.clearHandler
        }
      }
    )
  }
}
function renderInfo(h) {
  if (this.ttsCooldown > 0) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${Services.sendings}.warnings.tts`, { cooldown: this.ttsCooldown }),
          color: Colors.warning
        }
      }
    )
  }
}
function renderSecondRow(h) {
  if (!isEmpty(this.ttsFile) || this.ttsCooldown > 0) {
    return h(
      'div',
      {
        class: `${Services.sendings}-create__form-tts-row`
      },
      [
        renderFilePlayer.call(this, h),
        renderInfo.call(this, h)
      ]
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__form-tts`
    },
    [
      renderFirstRow.call(this, h),
      renderSecondRow.call(this, h)
    ]
  )
}
